/** @format */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { _$, Tabs, Tab } from '@king-design/react'
import TabAllTarget from './TabAllTarget'
import TabSelected from './TabSelected'
import _ from 'lodash'
export interface INameSpaceObject {
  metricCount: number
  nameSpace: string
}
export interface ITargetTabsProps {
  className?: string
  region: string
  nameSpace: INameSpaceObject[]
  metricListObject: any
  metricTotalCount: number
  queryNameSpace: string
  setQueryNameSpace: (value: any) => void
  queryMetric: string
  setQueryMetric: (value: any) => void
  getChartData: () => void
  getNameSpace: () => void
  getAllMetricList: () => void
  updatePeriod?: any
}

const TargetTabs: React.FC<ITargetTabsProps> = ({ className, updatePeriod, ...props }) => {
  const [currentTab, setTab] = useState('all') // 当前tab
  const [tableMetricList, setTableMetricList] = useState([]) // 当前region下已选绘成图表指标的list

  useEffect(() => {
    const updateTableMetricList = updatePeriod.filter(item => item.region === props.region)
    setTableMetricList(updateTableMetricList)
  }, [updatePeriod])

  // 更新localStorage以及tableMetricList数据
  const updateLocalMetricList = updateList => {
    const { region } = props
    const cloneUpdateList = _.cloneDeep(updateList)
    const updateTableMetricList = cloneUpdateList.filter(item => item.region === region)
    setTableMetricList(updateTableMetricList)
    localStorage.setItem('metricList', JSON.stringify(updateList))
    props.getChartData()
  }

  // 当切换region的时候，重新从localStorage中拿对应region的数据
  useEffect(() => {
    if (props.metricListObject && props.region && props.nameSpace.length) {
      const localMetricList = JSON.parse(localStorage.getItem('metricList')) || []
      // 把localStorage中已经删除的metric过滤掉
      const deleteMetricList = localMetricList.filter(item => {
        // 获取当前命名空间下的指标
        const currentNameSpace = props.metricListObject[item.nameSpace]
        if (!currentNameSpace) {
          return true
        }
        // 如果有命名空间，则先对比region（可能不同region下命名空间重名）再对比uniqueId
        const find = currentNameSpace?.find(
          objectItem => objectItem.region !== item.region || objectItem.uniqueId === item.uniqueId
        )
        return find
      })
      if (localMetricList?.length !== deleteMetricList.length) {
        localStorage.setItem('metricList', JSON.stringify(deleteMetricList))
      }
      // 获取当前region下的metric
      const updateMetricList = deleteMetricList.filter(
        localItem => localItem.region === props.region
      )
      setTableMetricList(updateMetricList)
    }
  }, [props.region, props.metricListObject, props.nameSpace])

  return (
    <div className={className}>
      <Tabs
        value={currentTab}
        onChangeValue={tab => {
          setTab(tab)
          if (tab === 'all') {
            props.setQueryNameSpace('')
          }
        }}
      >
        <Tab value="all">{_$('所有指标')}</Tab>
        <Tab value="selected">
          {_$('已选绘成图表指标')}(<span>{tableMetricList?.length || 0}</span>)
        </Tab>
      </Tabs>
      {currentTab === 'all' && (
        <TabAllTarget {...props} updateLocalMetricList={updateLocalMetricList} />
      )}
      {currentTab === 'selected' && (
        <TabSelected
          region={props.region}
          tableMetricList={tableMetricList}
          updateLocalMetricList={updateLocalMetricList}
        />
      )}
    </div>
  )
}

export default styled(TargetTabs)`
  min-height: calc(100vh - 598px);
`
